<template>
  <div class="record-type-selector" data-testid="record-type-selector">
    <a-space direction="vertical" style="width: 100%;">
      <div class="selector-header">
        <span class="selector-title" data-testid="record-type-title">Record Types</span>
        <a-space>
          <a-button size="small" @click="selectAll" data-testid="select-all-records-button">Select All</a-button>
          <a-button size="small" @click="selectNone" data-testid="clear-records-button">Clear</a-button>
        </a-space>
      </div>
      
      <a-checkbox-group v-model:value="localSelectedTypes" style="width: 100%;" data-testid="record-type-checkbox-group">
        <a-row :gutter="[16, 16]">
          <a-col
            v-for="recordType in recordTypes"
            :key="recordType.value"
            :xs="12"
            :sm="8"
            :md="6"
          >
            <a-checkbox :value="recordType.value" :data-testid="`record-type-${recordType.value.toLowerCase()}`">
              <a-tooltip :title="recordType.description">
                <span>{{ recordType.value }}</span>
              </a-tooltip>
            </a-checkbox>
          </a-col>
        </a-row>
      </a-checkbox-group>
    </a-space>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface RecordType {
  value: string
  description: string
}

interface Props {
  modelValue: string[]
}

interface Emits {
  (e: 'update:modelValue', value: string[]): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const recordTypes: RecordType[] = [
  { value: 'A', description: 'IPv4 address records' },
  { value: 'AAAA', description: 'IPv6 address records' },
  { value: 'CNAME', description: 'Canonical name records (aliases)' },
  { value: 'MX', description: 'Mail exchange records' },
  { value: 'NS', description: 'Name server records' },
  { value: 'PTR', description: 'Pointer records (reverse DNS)' },
  { value: 'SRV', description: 'Service records' },
  { value: 'SOA', description: 'Start of authority records' },
  { value: 'TXT', description: 'Text records' },
  { value: 'CAA', description: 'Certificate authority authorization' }
]

const localSelectedTypes = computed({
  get: () => props.modelValue,
  set: (value: string[]) => emit('update:modelValue', value)
})

const selectAll = () => {
  emit('update:modelValue', recordTypes.map(rt => rt.value))
}

const selectNone = () => {
  emit('update:modelValue', [])
}
</script>

<style scoped lang="scss">
.record-type-selector {
  .selector-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    gap: 12px;

    @media (max-width: 576px) {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .selector-title {
      font-weight: 600;
      font-size: 14px;
    }
  }
}
</style>
